export default [
  { routeName: "companiesEdit", tabTitle: "Datos de la empresa" },
  { routeName: "companies-courses", tabTitle: "Convocatorias" },
];
